var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcceptationRefused(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_795",
    "data-name": "Groupe 795",
    transform: "translate(-177.47 -108.973)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_394",
    "data-name": "Groupe 394",
    transform: "translate(-1177.053 -543.549)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_2",
    "data-name": "Exclusion 2",
    d: "M4728.023,22433.521a10.5,10.5,0,1,1,10.5-10.5A10.512,10.512,0,0,1,4728.023,22433.521Zm-4.875-11.152h0v1.3h9.751v-1.3Z",
    transform: "translate(-3363 -21760)",
    fill: "#ce3030"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptationRefused);
export default __webpack_public_path__ + "static/media/acceptation_refused.34023705.svg";
export { ForwardRef as ReactComponent };